
const muiTheme = {
  palette: {
    primary1Color: 'rgb(0, 154, 60)',
    primary2Color: 'rgb(0, 154, 60)',
    pickerHeaderColor: 'rgb(0, 154, 60)'
  }
};

export default muiTheme;


// WEBPACK FOOTER //
// ./src/defaultTheme.js